export default {
    additionalProducts: 'Produse suplimentare:',
    cifLabelMD: 'IDNO',
    registrationNumberLabelMD: 'Adresa fizică',
    regionLabelMD: 'Raion',
    globalTextAttirbuteNoOptions: `Nu sunt optiuni disponibile`,
    deliveryToChisinau: 'Livrare în Chișinău',
    deliveryToRegion: 'Livrare în Moldova',
    foundGoods: 'Produse găsite:',
    defaultSortingType: 'Mai nou',
    reset: 'Resetare',
    ready: 'Efectuat',
    clearAll: 'Ștergeți toate',
    productListPage: 'Lista de produse',
    globalMessageIutecreditFailed: `Momentan comanda nu poate fi efectuată folosind metoda Iutecredit. Încercați mai tărziu`,
    casaCart: `Cos`,
    errPromoCode: 'Codul promoțional introdus este incorect',
    becomePartner: {
        defTitle: 'Deveniți partenerul nostru și primiți beneficii exclusive',
        defDescription:
            'Completați formularul de mai jos pentru a începe colaborarea și pentru a vă dezvolta succesul împreună cu noi.',
        fullName: 'Nume Prenume',
        fullNamePlaceholder: 'Introduceți numele dvs. complet',
        legalForm: 'Tipul persoanei',
        legalFormPlaceholder: 'Alegeți o formă juridică',
        legalEntity: 'Pers. Juridică',
        individual: 'Pers. Fizică',
        registrationNumber: 'Codul fiscal (IDNP)',
        phone: 'Telefon',
        email: 'Email',
        emailPlaceholder: 'Trimite e-mail',
        successMessage: 'Formularul a fost trimis cu succes.',
        btn: 'Devino partener'
    },
    categoryProduct: 'produs',
    categoryProducta: 'produse',
    categoryProducts: 'produse',
    availabilityInStores: 'Disponibilitate în magazine',
    availabilityInStoresOutOfStock: 'Stoc Epuizat',
    callNow: 'Suna acum',
    viewOnMap: 'Vezi pe harta',
    availabilityInStoresInStock: 'În stoc',
    availabilityInStoresUnits: 'unități',
    limitedStock: 'Stoc limitat',
    commentsPlaceholder: 'Scrie un comentariu',
    comments: 'Comentariu',
    generalCharacteristics: 'Caracteristici generale',
    productAddedToReview: 'Recenzia dumneavoastra a fost trimisa cu succes',
    emptyCompare: 'Nu există produse de comparat',
    firstToKnow: {
        successText: `Vă mulțumim pentru solicitarea dumneavoastră!
        De îndată ce articolul este din nou în stoc, vă vom trimite imediat o notificare. Rămâneți pe recepție pentru mai multe noutăți!`,
        title: 'Află primul!',
        username: 'Nume și prenume',
        email: 'Email',
        comment: 'Comentariu',
        submit: 'Trimite',
        button: 'Notificare stoc !'
    },
    globalTextAttributeReviews: `recenzii`,
    globalTextAttributePlaceholderEmail: `example@email.com`,
    globalTextAttributeActionSend: `Trimite`,
    globalTextAttributeWrite: `Scrie...`,
    pageProductTabDescriptionTitle: 'Descriere',
    pageProductTabDescriptionSubTitle: 'Caracteristicile produsului',
    pageProductTabReviewsTitle: 'Reviews',
    pageProductTabCharacteristics: 'Caracteristici',
    reviewsTitle: `Recenziile produsului`,
    reviewsSectionEmptyDescription: `Nimeni încă nu a scris o recenzie despre acest produs. Împărtășiți-vă experiența cu alții.`,
    reviewsActionCreateReview: `Scrie o recenzie`,
    modalSendProductReviewTitle: `Lasă o recenzie`,
    modalSendProductReviewFormTitle: `Apreciază produsul`,
    modalSendProductReviewFormInputMessageLabel: `Recenzia ta`,
    modalSendProductReviewFormInputNameLabel: `Nume`,
    modalSendProductReviewFormInputEmailLabel: `Email`,
    modalSendProductReviewFormInputUnitVeryBad: `Foarte rău`,
    modalSendProductReviewFormInputUnitBad: `Rău`,
    modalSendProductReviewFormInputUnitNormal: `Normal`,
    modalSendProductReviewFormInputUnitGood: `Bine`,
    modalSendProductReviewFormInputUnitExcelent: `Excelent`,
    modalSendProductReviewFormMessageRequired: `Completati toate câmpurile necesare`,
    modalSendProductReviewFormMessageRequestFailed: `Selectati nota ratingului produsului`,
    modalSendProductReviewFormMessageRequestSuccess: `Recenzia dumneavoastra a fost trimisa cu succes`,
    addedToCart: 'Adaugat',
    availability: 'Disponibilitate',
    availabilityOutOfStock: 'Stoc epuizat',
    availabilityInStock: 'În stoc',
    weAlsoRecommend: 'Iti mai recomandam si',
    globalTextAttributePlaceholderEmail: 'ex. exemplu@gmail.com',
    globalTextAttributeCurrencyFolk: `lei`,
    globalPickUpMethodStore: `Ridicare din magazin`,
    globalPaymentMethodCash: `Cash`,
    globalPaymentMethodOnline: `Achitare Online`,
    globalPaymentMethodCredit: `Achitare in credit`,
    globalPaymentMethodRecount: `Prin transfer bancar`,
    globalPaymentMethodCardOnReceipt: `Card bancar la livrare`,
    globalPaymentMethodCashOnReceipt: `Cash la livrare`,
    globalPickUpMethodDelivery: `Livrare la domiciliu`,

    pageCartActionClearCart: `Goleste coșul`,
    pageCartScreenEmptyText: `Coșul este gol`,
    pageCartSectionCreditScreenEmptyText: `Produsele din coșul dvs. nu conțin oferte de credit.`,

    pageCartFormSegmentContactsTitle: `Contacte`,
    pageCartFormSegmentContactsInputNameLabel: `Nume Prenume`,
    pageCartFormSegmentContactsInputPhoneLabel: `Telefon`,
    pageCartFormSegmentContactsInputEmailLabel: `Email`,
    pageCartFormSegmentPaymentTitle: `Achitare`,
    pageCartFormSegmentPaymentSelectTypeLabel: `Alege oferta portivita`,
    pageCartFormSegmentPaymentSelectDateLabel: `Data/Anul nașterii`,
    pageCartFormSegmentDeliveryTitle: `Livrare`,
    pageCartFormSegmentDeliveryInputRegionLabel: `Regiune`,
    pageCartFormSegmentDeliveryInputRegionPlaceholder: `Selecteaza regiunea`,
    pageCartFormSegmentDeliveryInputLocationLabel: `Localitate`,
    pageCartFormSegmentDeliveryInputLocationPlaceholder: `Selecteaza localitatea`,
    pageCartFormSegmentDeliveryInputLocationMessageNoOptions: `Nu a fost găsit nimic`,
    pageCartFormSegmentDeliveryInputAddressLabel: `Adresa`,
    pageCartFormSegmentDeliveryMessageDeliveryTitle: `Livrare la domiciliu`,
    pageCartFormSegmentDeliveryMessageDeliveryDescription: `În Chișinău în sumă de la 5000 Lei - Gratuit <br> În afara Chișinăului - 14 lei/km`,
    pageCartFormSegmentDeliveryMessagePickUpTitle: `Ridicare din magazin`,
    pageCartFormSegmentDeliveryMessagePickUpDescription: `Addressa pick up point`,
    pageCartFormSegmentAdditionalInputMessageLabel: `Scrie`,
    pageCartFormSegmentAdditionalTogglerLabel: `Adauga un comentariu`,
    pageCartFormFooterTextAttributeSubtotal: `Subtotal`,
    pageCartFormFooterTextAttributeDelivery: `Livrare`,
    pageCartFormFooterTextAttributeTotal: `Total`,
    pageCartFormFooterCheckboxLabel: `Sunt de acord cu Termenii și condițiile`,
    pageCartFormFooterActionSubmit: `Plaseaza comanda`,
    pageCartFormMessageFieldsRequired: `Completati toate câmpurile necesare`,
    pageCartTitle: `Coșul de cumparaturi`,
    pageCartFormSegmentContactsInputNameLabel: `Nume Prenume`,
    pageCartFormSegmentContactsInputNamePlaceholder: `Scrie numele si prenumele`,
    pageCartFormSegmentContactsInputCompanyNameLabel: 'Denumirea companie',
    pageCartFormSegmentContactsInputFiscalCodeLabel: 'Cod fiscal (IDNO)',
    pageCartFormSegmentContactsInputLegalAdressLabel: 'Adresa juridică',
    pageCartFormSegmentContactsInputIbanLabel: 'IBAN',
    pageCartFormSegmentContactsInputBankCodeLabel: 'Codul băncii',
    pageCartFormSegmentDeliveryInputStoreLabel: `Magazine`,
    pageCartFormSegmentDeliveryInputStorePlaceholder: `Selectați un magazin`,

    news: 'Noutăți',
    reviews: 'Video review',
    reviewsMoreBtn: 'Mai mult',
    promotions: 'Promoții',
    allPromotions: 'Toate promoțiile',
    promotionExpired: 'Promoție finalizată',
    testimonials: 'Recenzii',
    company: 'Compania',
    contacts: 'Contacte',
    themeDark: 'Temă întunecată',
    themeLight: 'Temă luminoasă',
    dayOffer: 'Oferta zilei',
    vacancies: 'Posturi vacante',
    productsCatalogue: 'Catalogul produselor',
    popularQueries: 'Căutări populare',
    refresh: 'Reîncarcă',
    allSearchResults: 'Toate rezultatele căutării [{count} de produse]',
    resultsOnCategories: 'rezultatele în categorie',
    all: 'Toate',
    findDetails: 'Află detalii',
    compareAddOneMoreText: 'Pentru a compara trebuie de a adaugă cel puțin încă un produs',
    compareAddProduct: 'Adaugă produse',
    noProductsCompareText: 'Nu sunt produse pentru comparare',
    goToCatalog: 'Treci în catalog',
    look: 'Deschide {name}',
    cartProducts: 'Coșul cu produse',
    checkProducts: 'Alege produse',
    emptyFavorites: 'Nu aveți nici un produs in lista produselor favorite',
    delete: 'Șterge',
    configuration: 'Configurare',
    productsPrice: 'Costul produselor',
    delivery: 'Livrare',
    deliveryText: 'Livrare rapidă și sigură',
    deliveryTooltipText:
        'Adăugați produse minim de  <span>{count}</span> de lei pentru a primi <span>livrare gratuită</span> pe tot teritoriul României.',
    deliveryConditions: 'Condițiile livrării',
    compatibleProducts: 'Produse recomandate',
    notChosen: 'nu sunt alese',
    discount: 'Reducere',
    missing: 'Lipsește',
    makeRequest: 'Trimite cererea',
    makeRequestService: 'Trimite',
    actualPromos: 'Promoții curente',
    populars: 'Populare',
    newest: 'Noi',
    newProduct: 'Nou',
    addToCart: 'În coș',
    downloadPDF: 'Descarcă PDF',
    currency: 'lei',
    call: 'Sună-ne',
    catalog: 'Catalog',
    cart: 'Coș',
    productAddedToCart: 'Produsul a fost adăugat în coș',
    exitMessage: 'V-ați deconectat cu succes de la contul dvs',
    loginMessage: 'V-ați autentificat cu succes în contul dvs',
    preorderTitle: 'Precomandă',
    openCart: 'Deschide coșul',
    doYouWantInOurTeam: 'Alătură-te echipei noastre',
    allVacancies: 'Toate posturile vacante',
    published: 'Publicat',
    allArticles: 'Toate articolele',
    lookAllArticles: 'Vezi toate articolele',
    videoReviews: 'Video-Reviews',
    allVideoReviews: 'Toate video-reviews',
    nextVideoReviews: 'Următorul video-reviews',
    ourShops: 'Magazinele noastre',
    ourShopLinkName: 'Construiți traseul',
    ourShopSchedule: 'Grafic de lucru',
    ourShopContact: 'Suport clienți',
    buildRoute: 'Construiește  traseul',
    scheduleDaily: 'Luni – Vineri de la {fromTo}',
    scheduleWeekend: 'Sâmbătă – Duminica de la {fromTo}',
    searchNoResults: 'Căutarea nu a returnat niciun rezultat',
    videoReview: 'Video-Review',
    compare: 'Compară',
    save: 'Favorite',
    promoDetails: 'Detaliile promoției',
    productCode: 'Codul produsului',
    readMore: 'Citește mai mult',
    stockTitle: 'Stock',
    stockAvailable: 'Este în stock',
    stockUnavailable: 'Nu este în stock',
    memorySize: 'Capacitatea memoriei',
    addProdToCart: 'Adaugă în coș',
    similarProducts: 'Produse asemănătoare',
    copyLink: 'Copie Link-ul',
    linkCopied: 'Link-ul a fost copiat cu succes',
    backToCatalog: 'Înapoi în catalog',
    properties: 'Proprietăți',
    addedToCompare: 'Produsul a fost adăugat spre comparație',
    removedFromCompare: 'Produsul a fost șters din comparație',
    openCompare: 'Deschide compararea',
    hideDescription: 'Ascunde descrierea',
    fullName: 'Numele în întregime',
    fullNameService: 'Numele, prenumele',
    phone: 'Telefon',
    closeAndCancel: 'Continuă cumpărăturile',
    sendRequest: 'Trimite cererea',
    buyOneClick: 'Cumpără rapid',
    leavePhoneNumberText: 'Lasă numărul și te vom telefona înapoi în timp de 15 minute pentru a răspunde la toate întrebările',
    leavePhoneNumberTextPreorder: 'Lăsați-ne numărul de telefon, iar noi în decurs de 15 minute vă vom contacta.',
    contactPhone: 'Număr de telefon',
    checkout: 'Plaseaza comanda',
    contactUsBuyClickText: 'Ne poți contacta la numărul de telefon',
    contactUsBuyClickTextList: '<ul>\n' + '<li>Lu - Vn: 9:00 - 18:00</li> \n' + '<li>Si: 9:00 - 14:00</li> \n' + '</ul>',
    compareProducts: 'Compararea produselor',
    mark: 'A evidenția',
    onlyDifference: 'Doar diferențele',
    showAll: 'Vezi toate',
    similarity: 'Asemănări',
    addProduct: 'Adaugă produsul',
    cantCompareProducts: 'Nu putem compara produse din diferite categorii',
    deleteAllProducts: 'Șterge toate produsele',
    sort: 'Sortează',
    loadMore: 'încarcă mai mult',
    requestOrder: 'Creează comanda',
    personalDates: 'Date personale',
    personalDatesClient: 'Datele personale a clientului',
    enterNameSurname: 'Introdu numele si prenumele',
    required: 'Acest câmp este obligatoriu',
    rePasswordErrorText: 'Cele două câmpuri pentru parole nu coincid.',
    errPhoneNumberFormat: 'Formatul numărului este incorect.',
    email: 'Email',
    agreeWith: 'Eu sunt de acord cu',
    termsAndConditions: 'termeni și politica de confidențialitate',
    payment: 'Achitare',
    paymentMethod: 'Modalitate de achitare',
    cash: 'cash',
    bankKart: 'card bancar',
    deliveryMethod: 'Metoda de livrare',
    deliveryToAddress: 'Livrare la adresă',
    selfPickupShop: 'Ridicare în magazin',
    regions: 'Regiune',
    localities: 'Localitate',
    sector: 'Sector',
    deliveryAddress: 'Adresă de livrare',
    streetNumber: 'Numele străzii, casa și numărul apartamentului',
    pickupShopInfo: 'Momentan, ridicarea din magazin este posibilă doar la magazinul de pe adresa ',
    productsList: 'Lista produselor',
    productAddedToFavorites: 'Produsul a fost adăugat la favorite',
    productRemovedToFavorites: 'Produsul a fost șters din favorite',
    openFavorites: 'Deschide favorite',
    favorites: 'Favorite',
    partners: 'Parteneri',
    deleteFavorites: 'Șterge toate produsele din favorite',
    searchResults: 'Rezultatele căutării pentru',
    backToBlog: 'Înapoi la blog',
    recArticles: 'Articole recomandate',
    years1: 'ani',
    years2: 'ani',
    years3: 'ani',
    share: 'Distribuie',
    until: 'până la',
    doRequestCareer: 'Aplică cererea',
    sendCv: 'Trimite cererea',
    fullFillCv: 'Completați câmpurile',
    nothingSelected: 'Nimic selectat',
    selectNothingWasFound: 'Nimic nu a fost gasit',
    durationVideo: 'Durata: 1 minute',
    timer: {
        days: 'Zile',
        hours: 'Ore',
        minutes: 'Minute',
        seconds: 'Secunde'
    },
    voucher: {
        useLabel: 'Folosiți-l pentru achiziția dvs!',
        getNow: 'Primește-l acum',
        available: 'Valabil'
    },
    time: {
        hour: 'ora',
        min: 'min',
        sec: 'sec'
    },
    placeholder: {
        search500: 'Căutați printre  {count}+ de produse',
        enterFullName: 'Introduceți numele și prenumele',
        enterEmail: 'Introduceți adresa de e-mail',
        streetNumber: 'Numele străzii, casa și numărul apartamentului',
        enterEmail2: 'Introduceți e-mailul dvs',
        chosePosition: 'Alege postul vacant',
        enterPhone: 'Introdu numărul de telefon',
        dontCallComments: 'Lăsați contactul dvs. pentru comunicarea prin messenger'
    },
    titles: {
        main: 'Pagina principală',
        header: {
            logo: 'Pagina principală',
            catalogButton: 'Catalog produse',
            searchInput: 'Introduceți numele sau codul produsului',
            searchIcon: 'Caută',
            cabinetIcon: 'Cabinetul personal',
            favoriteIcon: 'Favorite',
            compareIcon: 'A compara',
            cartIcon: 'Coș',
            changeLangIcon: 'Schimbă limba',
            changeTheme: 'Schimbă tema',
            phone: 'Apelează-ne'
        },
        mainPage: {
            bannerNext: 'Următor',
            bannerPrevious: 'Precedent',
            vacanciesButton: 'Vezi toate posturile vacante',
            moreDetailsButton: 'Vezi întreaga recenzie',
            allNewsButton: 'Vezi toate articolele',
            newsTabNew: 'Vezi articolele noi',
            newsTabPopular: 'Vezi articolele populare',
            videoReviewsButton: 'Vezi toate video_reviews',
            ourStores: 'Vezi toate adresele',
            addressSelect: 'Vezi adresa'
        },
        productCard: {
            imageName: '{denumirea_produsului}',
            favoriteIcon: 'Adaugă în lista de favorite',
            compareIcon: 'Adaugă în lista de comparație',
            cartIcon: 'Adaugă în coș',
            price: 'Prețul actual',
            oldPrice: 'Prețul vechi',
            oneClickBuyIcon: 'Cumpără într-un click',
            creditPrice: 'Rata lunară',
            priceCashback: 'Valoare cashback',
            disableIcons: 'Nu este în stock'
        },
        footer: {
            socialNetworkIcons: ['Facebook', 'Instagram', 'Viber', 'Telegram', 'WhatsApp', 'Youtube', 'Twitter', 'TikTok'],
            phone: 'Apelează-ne'
        },
        productPage: {
            backButton: 'Înapoi la categorie',
            videoButton: 'Urmăriți video-review',
            favoriteButton: 'Adaugă în lista de favorite',
            compareButton: 'Adaugă în lista de comparație',
            productId: 'Codul produsului',
            nextImage: 'Următoarea imagine',
            prevImage: 'Precedenta imagine',
            buttonDescription: 'Afișează întreaga descriere',
            price: 'Prețul actual',
            oldPrice: 'Prețul vechi',
            sizeSelect: 'Alege mărimea',
            colorSelect: 'Alege culoarea',
            cartButton: 'Adaugă în coș',
            creditButton: 'Calculator credit',
            priceCashback: 'Valoare cashback',
            oneClickBuy: 'Cumpără într-un click'
        },
        catalog: {
            filters: {
                openFeature: 'Deschide filtrul',
                closeFeature: 'Închide filtrul'
            },
            viewTypeList: 'Vizualizează sub formă de listă',
            viewTypeGrid: 'Vizualizează sub formă de grid'
        },
        favoritePage: {
            deleteButton: 'Șterge toate produsele',
            moreProductsButton: 'Încarcă mai multe produse',
            addProductsButton: 'Adaugă produse'
        },
        comparePage: {
            addProductsButton: 'Adaugă produse',
            imageProduct: '{denumirea_produsului}',
            price: 'Prețul actual',
            oldPrice: 'Prețul vechi',
            deleteIcon: 'Șterge produsul',
            iconMore: 'Afișează toate caracteristicile',
            iconLess: 'Ascunde caracteristicile',
            selectDropDown: 'Afișează asemănări / diferențe'
        },
        cart: {
            checkout: {
                closeIcon: 'Închide coșul',
                decrementQuantity: 'Micșorează cantitatea',
                incrementQuantity: 'Mărește cantitatea',
                price: 'Prețul actual',
                deleteIcon: 'Șterge produsul',
                costText: 'Costul produselor',
                deliveryText: 'Costul livrării'
            },
            cartNextStep: 'Pasul următor',
            nameInput: 'Introduceți numele și prenumele',
            phoneInput: 'Introduceți numărul de telefon',
            emailInput: 'Introduceți adresa de e-mail',
            paymentSelect1: 'Achitare cash',
            paymentSelect2: 'Achitare cu card bancar',
            paymentSelect3: 'Procurare în credit',
            deliverySelect1: 'Livrare la domiciliu',
            deliverySelect2: 'Ridicare din magazin',
            deliveryAddressSelect1: 'Selectați regiunea',
            deliveryAddressSelect2: 'Selectați localitatea',
            deliveryAddressSelect3: 'Indicați adresa de livrare (strada, casa, nr. apartament)',
            deliveryAddressSelect4: 'Livrare standart',
            deliveryAddressSelect5: 'Livrare express',
            closeButton: 'Închide coșul',
            confirmButton: 'Plasează comanda',
            promocodeSend: 'Primește reducere'
        }
    },
    monthNames: {
        m1: 'ianuarie',
        m2: 'februarie',
        m3: 'martie',
        m4: 'aprilie',
        m5: 'mai',
        m6: 'iunie',
        m7: 'iulie',
        m8: 'august',
        m9: 'septembrie',
        m10: 'octombrie',
        m11: 'noiembrie',
        m12: 'decembrie'
    },
    at: 'la',
    showOnMap: 'Arată pe hartă',
    sortPriceMinus: 'De la cel mai mic preț',
    sortPricePlus: 'De la cel mai mare preț',
    sortNameMinus: 'După denumire',
    sortNamePlus: 'După denumire invers',
    sortPriorityMinus: 'Popular',
    deliveryType: 'Tip livrare',
    standart: 'Standart',
    express: 'Express',
    serverError: 'Server Error',
    serverErrorText: 'Din păcate la moment a apărut o eroare, încercați mai târziu.',
    errorNotFound: 'Pagina nu a fost găsită, verificați link-ul introdus în bara de adrese',
    previousPage: 'Pagina precedentă',
    errorNotFoundBtn: 'Pagina principală',
    checkoutSuccess: 'Comanda a fost transmisă cu succes',
    checkoutSuccessSubtitle: 'Numărul comenzii: #{orderNumber}. Curînd un consultant v-a lua legătura cu Dumneavoastră',
    showMore: 'Arată mai mult',
    showLess: 'Arată mai puțin',
    filter: 'Filtre',
    filterApply: 'Aplica',
    filterNotFound: 'Nu a fost găsit nimic conform filtrelor selectate',
    filterReset: 'Resetează filtrele',
    sorting: 'Sortare',
    paymentSuccess: 'Achitare reușită',
    price: 'Preț',
    authTitle: `Autorizare`,
    authInputLoginTitle: `Login-ul`,
    authInputLoginPlaceholder: `Introduceți login-ul`,
    authInputPasswordTitle: `Parola`,
    authReInputPasswordTitle: `Reintroduceți parola`,
    authInputPasswordPlaceholder: `********`,
    authInputError: 'Parolă sau login incorect',
    authSubmit: `Log in`,
    authLogIn: 'Logare',
    authExit: 'Ieșire',
    recipeErrorText: 'Confirmați disponibilitatea rețetei pentru acest produs.',
    noRecipeProductsText: 'Produsele menționate mai jos pot fi livrate la domiciliu!',
    continueButtonText: 'Continuă',
    deleteAllButtonText: 'Ștergeți întreaga listă',
    favoritesEmptyText: 'Lista preferințelor e goală!',
    restorePasswordTitle: 'Recuperare parolei',
    restorePasswordMainText: 'Introdu adresa ta de e-mail, la care vei primi instrucțiuni de recuperare a parolei.',
    restorePasswordTextStart: 'A fost trimis un e-mail la ',
    restorePasswordTextEnd: ' cu instrucțiuni pentru recuperarea parolei.',
    confirmRegisterTitle: 'Înregistrare',
    confirmRegisterText: 'La adresa de e-mail specificată a fost trimis un link. Dați click aici pentru a vă activa noul cont.',
    authModalSignIn: 'Logare',
    authModalRegister: 'Înregistrare',
    authRememberMe: 'Ține minte',
    authLoginButtonText: 'Intră în cont',
    authRegisterButtonText: 'Înregistrează-te',
    authModalTitle: 'Autentificare',
    authForgotPasswordText: 'Am uitat parola',
    insurances: 'Asigurare',
    serviceCenter: 'Service centru',
    schedule: 'Program',
    orders: 'Comenzi',
    creditVal: 'Credit',
    cashBack: 'cashback',
    formPricePerMonth: `de la {price} lei/luna`,
    to: 'pînă la',
    from: 'de la',
    month: 'luna',
    monthsOther: 'luni',
    chat: 'chat',
    support: 'Număr Service Centru ',
    back: 'Înapoi',
    gift: 'Cadou',
    selectedColor: 'Culoarea aleasă',
    GB: 'GB',
    toCredit: 'În credit',
    buyInCredit: 'Cumpără în credit',
    choseTypeCredit: 'Alege tipul creditului',
    choseTypeCreditCompany: 'Alegeți o societate de creditare',
    months: 'luni',
    rate: 'rată',
    certainItemsLikeNew: 'Telefon Nou acoperit cu o garantie contractuală de 24 luni pe teritoriul RM',
    showAllOptions: 'Arată toate opțiunile',
    hideAllOptions: 'Închide toate opțiunile',
    dontCallComments: 'Comentarii: Viber, WhatsApp, Telegram, Messenger',
    dontCallMe: 'Nu doresc să fiu apelat pentru confirmare',
    paymentCardMessage: 'Plata poate fi facută cu orice card bancar',
    paymentCommentaryTitle: 'Comentariu',
    paymentCommentaryPlaceholder: 'Adaugă un comentariu (opțional)',
    buyInCredit2: 'În credit',
    operator: 'Operator',
    cassir: 'Casier',
    about: {
        miMean:
            '”MI în logotipul nostru semnifică «Mobile Internet(internet mobil)», dar de asemenea pentru noi mai sună că\n' +
            '             <button class="quute__link">\n' +
            '               «Misiunea imposibilă»\n' +
            '               <span class="tooltip">\n' +
            '                                În engleză – <span class="tooltip__trans">Mission</span> <span class="tooltip__trans">Impossible</span>\n' +
            '                            </span>\n' +
            '             </button>\n' +
            '             Xiaomi s-a confruntat mereu cu diverse provocări, multe dintre acestea s-au dovedit inițial imposibil de realizat la începutul anilor de activitate.”',
        statistic:
            '<p>100+</p>\n' + '           <span>țările și regiunile în care sunt disponibile produsele Xiaomi Xiaomi</span>',
        text2010:
            'Xiaomi și-a început activitățile cu dezvoltarea firmware-ului MIUI, care a câștigat încrederea întregii lumi..',
        text2011: 'Compania și-a lansat propriul smartphone. S-a remarcat printr-un preț accesibil și parametri puternici..',
        text2013: 'Trei ani mai târziu, audiența MIUI a depășit 30 de milioane de oameni și continuă să crească constant..',
        text2014: 'Compania a reușit să ocupe locul 6 la vânzările de smartphone-uri de pe piață și continuă să mențină poziția.',
        socialTitle: 'Noi prețuim clienții ,deoarece ei nu sunt doar cumpărători',
        socialText:
            '<p>\n' +
            '               Ei sunt prietenii noștri apropiați și noi suntem mai mult decât vânzători de smartphone-uri, laptopuri și tablete.. Pentru ei suntem –\n' +
            '              colorați și mereu\n' +
            '               amintiri clare, jocuri captivante de performanță maximă, muzică preferată disponibilă\n' +
            '               la fiecare pas,\n' +
            '               confort  in casa.\n' +
            '             </p>\n' +
            '             <p>\n' +
            '               Vă puteți împărtăși emoțiile în toate rețelele de socializare. folosind hashtag-ul <span>#xiaomifamily</span>\n' +
            '               sau etichetează-ne. Fiecare\n' +
            '               postare ne încălzește cu adevărat inimile.\n' +
            '             </p>',
        socialNetworks: 'Rețelele noastre sociale',
        socialTitle2: 'Îi ajutăm să se îmbunătățească in format digital',
        socialText2:
            '<p>\n' +
            '               Scopul nostru este să ajutăm clienții noștri să țină pasul cu tendințele actuale ce tine de dispozitive și accesorii.. Noi credem, că acesta este cea mai\n' +
            '               corecta cale și  noi nu ne oprim niciodată, prin urmare îmbunătățim constant calitatea și varietatea serviciilor noastre.\n' +
            '              Vino în orice magazin Xiaomi și vezi singur. Creează-ți propriul stil și folosește cea mai recentă tehnologie\n' +
            '               subliniază-ți individualitatea. Crește in format digital și fii la modă!\n' +
            '             </p>',
        ourNews: 'Știrile noastre',
        childCompanies: 'Companii afiliate'
    },
    service: {
        title: 'Servicii de reparație a dispozitivelor electronice!',
        subTitle: 'Ai nevoie de ajutor?',
        requestConsultation: 'Vreau o consultație',
        itemText1: '<p>5000+</p>\n' + '                    <span>telefoane, laptopuri  și diverse dispozitive</span>',
        itemText2: '<p>4 ani</p>\n' + '                    <span>experiență în repararea tehnicii pe piața din Moldova</span>',
        letPhoneNumber: 'Lasă-ne numărul tău de telefon și revenim cu un apel în 15 minute',
        delayPrice: 'Termenii și costul reparației',
        itemTitle1: 'Instalarea și restaurarea Sistemului de Operare',
        from1: '200-300 lei',
        term1: 'Durata: 2 zile',
        itemTitle2: 'Înlocuirea componentelor interne',
        from2: '200-500 lei',
        term2: 'Durata: 3-14 zile',
        itemTitle3: 'Înlocuirea componentelor externe',
        from3: '200-500 lei',
        term3: 'Durata: 3-14 zile',
        urgentService: 'Reparaţia în regim de urgență',
        ourProcess: 'Ce se întâmplă cu dispozitivul tău, când ajunge la Service centru?',
        documentRequest: 'Înregistrarea dispozitivului.',
        documentRequestDesc: '',
        deviceDiagnostic: 'Diagnosticarea, stabilirea etapelor de reparație.',
        deviceDiagnosticDesc: '',
        defaultRepair: 'Reparație obișnuită',
        nonwarrantyRepair:
            'În cazul reparaţiilor în afara garanţiei, specialistul te va contacta pentru a stabili lucrările de reparație ce urmează a fi efectuate, costul acestora, precum şi termenul de predare.',
        nonwarrantyRepairDesc: '',
        techniqueControl: 'Testarea tehnică.',
        techniqueControlDesc: '',
        issuingDevice: 'Eliberare a dispozitivului – ridicare personală sau livrare.',
        issuingDeviceDesc: '',
        contacts: 'Contactele service-ului',
        addressTitle: 'Adresa centrului  service'
        //     address: 'mun.Chișinău ,str.Muncești 41',
        //     schedule:
        //         '<p>Lu - Vn: 09:00 – 18:00</p>\n' +
        //         '                    <p>Si: 09:00 – 14:00</p>\n' +
        //         '                    <p>Du: zi liberă</p>'
    },
    insurance: {
        noGuarantyTitle: 'Asigură-ți smartphone-ul în cazurile neprevăzute de garanție.',
        noGuarantyDescription:
            'Cu fiecare an smartphone-urile devin din ce în ce mai subțiri, iar conținutul intern - din ce în ce mai complex.',
        noGuarantyDescription2:
            'În cazul ecranului spart, costul reparației ar putea constitui până la 70% din prețul smartphone-ului. Iar dacă e să vorbim despre un eventual furt, va trebui să cumperi alt telefon. Atunci când procuri un dispozitiv, fă Asigurare Xiaomi și ai un an întreg de liniște.',
        itemTitle1: 'Ecranul spart',
        itemDescription1:
            'Conform statisticii, aproximativ 50% dintre utilizatorii de smartphone-uri s-au confruntat cu problema ecranului spart.\n' +
            ' Ai împins, întâmplător, telefonul de pe masă, l-ai scăpat în timp ce îl scoteai din buzunar sau geantă \n' +
            ' sau telefonul a alunecat din mână. ',
        itemTitle2: 'Deteriorări mecanice',
        itemDescription2:
            'Deteriorările mecanice sunt punctul slab al fiecărui smartphone. \n' +
            'Fie că ai scăpat telefonul jos sau ai uitat că îl ai în buzunarul de la spate al blugilor și te-ai așezat pe el; \n' +
            'ai scos brusc cablul de alimentare de la reţea sau căştile.',
        itemTitle3: 'Furtul',
        itemDescription3: 'Furtul telefonului este încă o situaţie neplăcută, care ți se poate întâmpla.',
        itemTitle4: 'Supratensiune electrică',
        itemDescription4:
            'Ai pus telefonul la încărcat, iar în reţea a avut loc o fluctuaţie de tensiune electrică și telefonul nu se mai încarcă, iar în unele cazuri nici nu se conectează.',
        itemTitle5: 'Contactul cu apa',
        itemDescription5:
            'Echipamentele tehnice şi apa sunt două extreme, care nu trebuie să se întâlnească niciodată. Iar dacă acestea se întâlnesc – e mare necaz.',
        faq: 'Întrebări frecvente',
        accordionTitle1: 'Ce dispozitive pot fi asigurate?',
        accordionDesc1:
            '<ul>\n' +
            '                      <li>Telefonul</li>\n' +
            '                      <li>Tableta</li>\n' +
            '                      <li>Laptopul</li>\n' +
            '                      <li>Televizorul</li>\n' +
            '                      <li>Ceasul inteligent</li>\n' +
            '                    </ul>',
        accordionTitle2: 'Cât costă asigurarea?',
        accordionDesc2:
            '<p>Costul asigurării este echivalent cu 15% din costul dispozitivului. Orice s-ar întâmpla în decurs de 1 an din momentul procurării: s-a spart ecranul, deteriorări mecanice – dispozitivul  va fi reparat gratuit. </p>\n' +
            '              <p>Iar dacă dispozitivul nu poate fi reparat – acesta va fi înlocuit cu unul nou.</p>',
        accordionTitle3: 'De câte ori pot utiliza garanția?',
        accordionDesc3: '<p>Poţi beneficia de acest serviciu numai o singură dată în decursul unui an.</p>',
        faqText: 'Dacă s-a întâmplat ceva cu dispozitivul tău, sună-ne la numărul'
    },
    discountPage: {
        title: 'Punctele de bonus <span>JBL</span>',
        subTitle: 'Îți place să faci cumpărături și să primești reduceri? Nouă ne place să le oferim!',
        attention: 'Vă rugăm să rețineți că curierul nu demonstrează funcționarea mărfii, nu o conectează și nici nu o montează.',
        benefitTitle: 'Avantajele <span>Discount</span>',
        benefitItemText1: 'puncte la înregistrare',
        benefitItemText2: 'puncte de ziua de nastere',
        benefitItemText3: 'cashback la cumparare',
        benefitItemText4: 'puncte la înregistrare',
        accordionTitle1: 'Ce sunt punctele bonus?',
        accordionContent1:
            '<p>\n' +
            '                        1 punct bonus = 1 leu. Având o anumită sumă de puncte în cont, beneficiezi garantat de reduceri la orice cumpărătură. \n' +
            '                       </p>',
        accordionTitle2: 'Cum primești punctele bonus?',
        accordionContent2:
            '<p>\n' +
            '                         Alătură-te programului nostru de acumulare a punctelor bonus Xiaomi și primești garantat reduceri. Accesează link-ul <a href="www.mi.md/viber">www.mi.md/viber</a> și urmează pașii pentru a te înregistra. La finalizarea înregistrării primești cadou 1000 de puncte! \n' +
            '                      </p>\n' +
            '                      <ul class="list__bonus">\n' +
            '                         <li>Primești 1000 puncte bonus la înregistrare, valabile peste 14 zile din momentul primirii.</li> \n' +
            '                         <li>Primești 500 puncte bonus de ziua ta de naștere, valabile din momentul primirii.</li> \n' +
            '                         <li>Primești o parte din suma achitată înapoi pe contul punctelor bonus (CashBack), valabile peste 14 zile din momentul primirii.</li> \n' +
            '                         <li>Achiți din contul punctelor bonus o parte din costul produselorla următoarea procurare.</li> \n' +
            '                         <li>La procurarea produselor promoționale, la fel, primești puncte bonus. Numărul de puncte obținute depinde de condițiile promoției. Valabile din momentul primirii.</li> \n' +
            '                      </ul>',
        accordionTitle3: 'Cum pot fi utilizate punctele bonus?',
        accordionContent3:
            '<p>\n' +
            'Poți folosi punctele bonus pentru a achita o parte din costul produsului ales. Tot ce trebuie să faci este să-i spui vânzătorului numărul tău de telefon, acesta va verifica în sisitem numărul de puncte disponibile și v-a efectua tranzacția. \n' +
            '</p>\n' +
            '<p><b>Reține!!!</b></p> \n' +
            '<ul class="list__bonus">\n' +
            '<li>Punctele acumulate nu pot fi convertite în echivalent bănesc și nu sunt emise în numerar.</li> \n' +
            '<li>Dacă produsul este la promoție și are preț redus, cadou sau este în Credit 0%, nu poți folosi punctele pentru achitarea acestui produs. Va trebui să alegi reducerea oferită în cadrul promoției sau utilizarea punctelor bonus.</li> \n' +
            '<li>Primești reducere numai în momentul procurării în magazinele noastre și din contul sumei de puncte disponibile la acel moment pentru acea achiziție.</li> \n' +
            '<li>Punctele acumulate vor fi active după 14 zile din momentul primirii și vor putea fi utilizate în decurs de 90 de zile.</li> \n' +
            '</ul>'
    },
    deliveryPage: {
        conditions: 'Condiții de livrare',
        tabTitle1: 'Livrare in Chisinau',
        tabTitle2: 'livrare urgenta',
        tabTitle3: 'Livrare în regiuni',
        tabText1: `Locuiești în Chișinău, așa că vei primi comanda a 2-a zi din momentul confirmării comenzii cu excepția zilei de duminică. Livrarea se efectuează de luni pînă sîmbată între orele 10:00 și 19:00. Cu o oră înainte de a primi livrarea, curierul vă va telefona.`,
        tabText2: `
    Vrei să primești comanda mai repede?
    Pentru aceasta avem un serviciu de livrare expres în Chișinău. Comenzi acest serviciu și primești achiziția în aceeași zi. Serviciul este disponibil pentru comenzile confirmate înainte de ora 15:00.
    Dacă este necesar, curierul va aduce gratuit mărfurile până la ușa apartamentului.`,
        tabText3: `Locuiești  într-una dintre regiunile țării noastre - comanda ta vă va ajunge în termen de 1-3 zile, cu excepția zilei de duminică. Termenul de livrare depinde de regiune. Curierul livrează marfa la intrarea sau la poarta casei.`,
        tab1Item1Text: 'Telefoane, laptopuri, accesorii',
        tab1Item2Text: 'Televizoare, biciclete, electrocasnice mici',
        tab1Item3Text: 'Electrocasnice mari',
        tab1Item4Text: 'Mobilier tapițat',
        attentionTab1:
            'Vă rugăm să rețineți că curierul nu demonstrează funcționarea mărfii, nu o conectează și nici nu o montează.',

        tab2Item1Text: 'Telefoane, laptopuri, accesorii',
        tab2Item2Text: 'Televizoare, biciclete, electrocasnice mici',
        tab2Item3Text: 'Electrocasnice mari',
        tab2Item4Text: 'Mobilier tapițat',
        attentionTab2:
            'Vă rugăm să rețineți că curierul nu demonstrează funcționarea mărfii, nu o conectează și nici nu o montează.',

        tab3Item1Text: 'Telefoane, laptopuri, accesorii',
        tab3Item2Text: 'Televizoare, biciclete, electrocasnice mici',
        tab3Item3Text: 'Electrocasnice mari',
        tab3Item4Text: 'Mobilier tapițat',
        attentionTab3:
            'Vă rugăm să rețineți că curierul nu demonstrează funcționarea mărfii, nu o conectează și nici nu o montează.'
    },
    creditPage: {
        conditions: 'Condițiile de creditare',
        conditions2: 'Ce trebuie să am pentru a primi un credit?',
        condition1: 'Creditul se acordă pe o perioadă de la 4 până la 48 de luni',
        condition2: 'Suma minimă a creditului este de 500 lei',
        condition3: '18 ani împliniţi',
        condition4: 'Buletinul de identitate valabil',
        condition5: 'O sursă stabilă de venit',
        insight:
            '<p>\n' +
            '                  Dacă rambursați creditul mai repede decat termenul stabilit, atunci suma totală care trebuie plătită va fi mult mai mică din cauza\n' +
            '                  eliminării\n' +
            '                  dobânzilor pentru lunile pe care le plătiți în avans.\n' +
            '                </p>'
    },
    footer: {
        connectWithUs: 'Contactează-ne',
        salesDepartment: 'Contacte',
        supportService: 'Serviciul suport clienţi',
        services: 'Servicii',
        companyHistory: 'Despre noi',
        officialShops: 'Magazine',
        newsAndArticles: 'Știri',
        videoReviews: 'Video Reviews',
        deliveryAndPayment: 'Livrare și achitare',
        internetShop: 'Eliberarea comenzilor online',
        terms: 'Termeni și politica de confidențialitate',
        info: 'Xiaomi',
        serviceCenter: 'Service centru',
        insurance: 'Asigurare',
        miDiscount: 'Discount',
        miCredit: 'Credit',
        credit: 'Credit',
        receiveNewsOnViber: 'Fii primul care află despre promoții și reduceri!',
        noSpamJustNews: 'Abonează-te pe Viber',
        subsribeToTelegramTitle: 'Abonează-te pe Telegram',
        subscribe: 'Mă abonez',
        developed: 'Dezvoltat de',
        toClients: 'Clienților',
        subscribeToNews: 'Abonați-vă la știri',
        hours: 'Program'
    },
    nearShops: 'Găsește cel mai apropiat magazin Xiaomi',
    serviceDecide: 'Service centru Xiaomi',
    serviceDecide2: 'Reparăm rapid orice dispozitiv!',
    serviceBtn: 'Află mai multe',
    gift1000: 'Cadou 1000 lei',
    onBonusAccount: 'pe bonus card',
    tryNow: 'Primește-i acum',
    promoIsActualUntil: 'Promoția este valabilă in perioda de pe 10 iulie pînă pe 10 octombrie 2023.',
    enterCorrectEmail: 'Introduceți email corect',
    summary: 'Total',
    info: 'Informație',
    enterRightNumber: 'Introduceți numarul corect',
    numberOfSimCards: 'Numărul de cartele SIM',
    stateOfProduct: 'Stare',
    tanksGetVoucher: 'Multumim! În scurt timp v-om lua legătura cu dumneavoastră!',
    get1000Gift: 'Primește cadou de 1000 de lei',
    enterPhone1000: 'Confirmă-ți identitatea, pentru a primi cadoul',
    take: 'Confirm',
    congrats: 'Felicitări!',
    requestIsSend: 'Acum ai 1000 lei pe bonus card.',
    requestSpan: 'În câteva clipe vei primi un sms de confirmare.',
    locations: {
        bubueci: 'Bubuieci',
        budsheti: 'Budești',
        vatra: 'Vatra',
        gidighici: 'Ghidighici',
        gratiesti: 'Grătiești',
        dumbrava: 'Dumbrava',
        kishinev: 'Chișinău',
        codru: 'Codru',
        colonitsa: 'Colonița',
        krikovo: 'Cricova',
        stavceni: 'Stăuceni',
        sinjera: 'Sîngera',
        cioresku: 'Ciorescu',
        balti: 'Bălți',
        tiraspoli: 'Tiraspol',
        cahul: 'Cahul',
        benderi: 'Bender',
        briceni: 'Briceni',
        drochia: 'Drochia',
        edineti: 'Edineț',
        cantemir: 'Cantemir',
        comrat: 'Comrat',
        novieaneni: 'Anenii noi',
        noviemereni: 'Merenii Noi',
        floreni: 'Floreni',
        orhei: 'Orhei',
        rezina: 'Rezina',
        soroka: 'Soroca',
        straseni: 'Strășeni',
        floresti: 'Florești',
        ungeni: 'Ungheni',
        chadirLunga: 'Ciadîr-Lunga',
        ialoveni: 'Ialoveni',
        edinet: 'Edineț',
        ungheni: 'Ungheni'
    },
    phones: {
        phone: '+373 79 221 188',
        phone1: '+373 78 800 723',
        phone2: '+373 22 02 21 50',
        phone3: '+373 78 80 07 23'
    },
    modalCreditSuccessTitle: 'Cererea a fost trimisă cu succes',
    terms: {
        h1: 'TERMENI ȘI CONDIȚII',
        p1: 'Prezenții Termeni și Condiții de utilizare a magazinului online www.xiaomistore.md sunt aplicabile comenzilor pentru achiziționarea produselor/serviciilor oferite de compania ALO SRL prin intermediul site-ului.',
        p2: 'Pentru folosirea în bune condiții a site-ului, vă recomandăm familiarizarea cu atenție a Termenilor și Condițiilor prezentate. Ne rezervăm dreptul de a face modificări ale acestor prevederi, fără o notificare prealabilă',
        deliveryCapital: 'LIVRARE ÎN CHISINAU',
        deliveryRegion: 'LIVRARE ÎN REGIUNI',
        deliveryProduct: 'Produsul',
        deliveryPriceTitleCapital: 'Costul livrării(Chisinau)',
        deliveryPriceTitleExpress: 'Cost de livrare express',
        deliveryPriceTitleRegion: 'Costul livrării'
    },
    order: {
        message: 'Comanda #{id} a fost finalizată cu succes. Mulțumim!',
        messageParagraph:
            'În curând vei fi contactat la numărul de telefon indicat. De asemenea vei primi detalii despre comanda ta pe email',
        messageBtn: 'Pagina principală',
        details: 'Detaliile comenzii',
        detailsInformation: 'Informații de contact',
        detailsDelivery: 'Livrare',
        detailsPayment: 'Achitare',
        detailsPaymentCard: 'Cu cardul online',
        detailsPaymentCash: 'În numerar',
        detailsPaymentCredit: 'În credit',
        products: 'produse',
        product: 'product',
        count: 'buc.'
    },
    modalSuccessTitle: 'Cererea a fost trimisă cu succes',
    temporaryCardPaymentNotWork: 'La moment nu este posibilă achitarea cu cardul, puteți alege alta metodă de achitare',
    sellerEmployeeTitle: 'Vânzător consultant',
    sellerEmployeeDescription: 'Alegeți un vânzător consultant',
    sellerEmployeeError: 'Alegerea vânzătorului consultant este neapărată!',
    shortLinkTitle: 'Link scurt',
    shortLinkDescription: 'Acesta este un link scurt, urmați-l pentru a citi conținutul',

    ordersTitle: 'Comenzi',
    ordersHeaderId: 'Comanda ID',
    ordersHeaderTotal: 'Suma totală a comenzii',
    ordersHeaderQuantity: 'Numărul de posturi',
    ordersHeaderDate: 'Data creării',
    ordersDataName: 'NUMELE CUMPĂRĂTORULUI NUMELE',
    ordersDataPhone: 'Număr de telefon',
    ordersDataEmail: 'Poștă',
    ordersDataBirth: 'Data nașterii',
    ordersDataPayment: 'Modalitate de plată',
    ordersDataComment: 'un comentariu',
    ordersDataSeller: 'Vanzator',
    ordersDataDelivery: 'Metoda de livrare',
    ordersDataStatus: 'Statul de plată',
    ordersDataStatusComplete: 'Plătit',
    ordersProductId: 'id produs',
    ordersProductName: 'Numele produsului',
    ordersProductPrice: 'Cost unitar',
    ordersProductTotal: 'cost total',
    pagination: {
        next: 'Urmatoarea',
        prev: 'Precedenta',
        last: 'Ultima',
        first: 'Prima'
    },
    recipeProductsText:
        'Produsele menționate mai jos nu pot fi livrate la domiciliu! Înlăturați-le din coș sau selectați Livrarea în farmacie.',
    regulationsTitle: 'Regulament',
    regulations: 'Regulamente',
    productDiscount: 'REDUCERE',
    productHit: 'HIT!',
    currencyNovaPorta: 'MDL',
    aboutUs: 'Despre noi',
    card_on_receipt: 'Card bancar la livrare',
    cash_on_receipt: 'Cash la livrare',
    recount: 'Prin transfer bancar',
    companyName: 'Denumirea companie',
    fiscalCode: 'Cod fiscal (IDNO)',
    legalAdress: 'Adresa juridică',
    iban: 'IBAN',
    bankCode: 'Codul băncii',
    subscribeError: 'Abonare cu acest email deja există',
    allProducts: 'Toate produsele',
    farmacie: {
        defaultSortingType: 'mai nou',
        descriptionAttentionText:
            '<span class="attention">Atenționare!</span> Nu trebuie să folosiți informațiile prezente în aceste pagini, în scopul diagnosticării sau tratării oricăror probleme de sănătate sau de înlocuire a medicamentelor și a tratamentelor prescrise de personalul medical autorizat. Toate informațiile din acest site sunt publicate cu scop informativ și pot conține unele erori, vă rugăm să vă ghidați doar după informația din prospect! Rareori informația de pe pagină poate conţine inadvertenţe: fotografia are caracter informativ şi poate, fi modificat de către producător fără preaviz sau pot conţine erori.',
        searchInputPlaceholder: 'căutare',
        currency: 'lei',
        allProducts: 'Toate produsele',
        myAccount: 'Contul meu',
        total: 'Total',
        savingAmount: 'Suma economisită',
        blog: 'Blog',
        allNews: 'Toate articolele',
        points: 'puncte',
        loyalty: 'de loialitate',
        latestPromotionsStart: 'Fiți la curent cu cele mai noi',
        latestPromotionsEnd: 'promoții',
        subscribe: 'Abonează-te',
        contactUsTitle: 'Contactează-ne',
        contactUsText: 'Vom fi bucuroși să răspundem la întrebările dvs. Contactați-ne în modul care vă convine cel mai bine',
        sendEmail: 'Trimite email',
        pharmaciesList: 'Lista farmacii',
        faq: 'Întrebări frecvente',
        aboutUs: 'Despre noi',
        information: 'Informații',
        conditionsAndCookies: 'Сondiții generale & Cookies',
        regulations: 'Regulamente',
        health: 'Sănătate',
        motherAndChild: 'Mama și Copilul',
        beauty: 'Frumusețe',
        blogFarmacie: 'Blog farmacie.md',
        subscribeTitle: 'Urmăriți-ne pe',
        searchResult: 'Rezultatele căutării',
        quickFilter: 'Filtrare rapidă',
        new: 'Noi',
        promo: 'Promo',
        topSeason: 'Top sezon',
        social: 'Sociale',
        benefit: 'Beneficii:',
        freeShipping: 'Livrare gratuită',
        searchInPharmacies: 'Caută în farmacii',
        productAppearanceNote: '*Rareori informația despre produs poate conţine inadvertenţe.',
        productDescription: 'DESCRIEREA PRODUSULUI',
        similarProducts: 'PRODUSE SIMILARE',
        productStock: 'DISPONIBILITATE ÎN FARMACII',
        showFullDescription: '+ Vezi descrierea completă',
        hideFullDescription: '- Ascunde descrierea completă',
        stock: 'Stoc:',
        compareProducts: 'Comparare',
        compare: 'Comparare',
        chooseCategory: 'Selectații o categorie',
        show: 'Arătați',
        allParameters: 'Toți parametrii',
        differences: 'Deosebirile',
        generalCharacteristics: 'Specificații principale',
        clearEntireList: 'Ștergeți întreaga listă',
        cart: 'COȘ',
        delivery: 'LIVRARE',
        payment: 'ACHITARE',
        promoCodeInstruction: 'Când dețineți codul promo, introduceți-l în câmpul corespunzător:',
        promoCode: 'Promo cod',
        getDiscount: 'OBȚINEȚI O REDUCERE',
        inCart: 'În coș sunt',
        product: 'produs',
        producta: 'produse',
        products: 'produse',
        forAmount: 'în sumă de',
        youWillReceive: 'Vei primi',
        loyaltyPoints: 'puncte de fidelitate',
        applyLoyaltyPoints: 'Aplică punctele de loialitate',
        totalSaved: 'Suma economisită în total:',
        contactMe: 'Doresc să fiu contactat',
        suggestions: 'Sugestii, comentari...',
        yourOrder: 'Sumar comandă',
        orderAmount: 'Total comandă',
        confirmOrderAgreementStart: 'Prin trimiterea comenzii accept',
        confirmOrderAgreementDelivery: 'termeni de livrare / returnare',
        confirmOrderAgreementEnd: ' precum și',
        confirmOrderAgreementPrivacy: 'politica de confidențialitate',
        calculateDelivery: 'Calculați livrarea',
        preliminaryDate: 'DATA ȘI ORA ESTIMATIVĂ DE LIVRARE',
        date: 'Data',
        time: 'Ora',
        deliveryInPharmacy: 'Livrare în farmacii',
        deliveryToHome: 'Livrare la Domiciliu',
        regions: 'REGIUNI',
        localities: 'LOCALITĂȚI',
        sector: 'SECTOARE',
        map: 'Harta',
        address: 'Adresa',
        openingHours: 'Orele de lucru',
        telephone: 'Telefon',
        choosePharmacy: 'Selectează farmacia',
        choose: 'Selectează',
        deliveryAddress: 'Adresa de livrare',
        addDeliveryAddress: '+ Adăugați o altă adresă de livrare',
        commentText: 'Comentariu | daca livrarea este pentru alta persoana va rog introduceti numarul de telefon in comentariu !',
        commentLength: 'Comentariu, nu mai mult de 100 caractere',
        backToAddresses: 'Înapoi la adrese',
        deliveryIn: 'Livrare în',
        street: 'Stradă',
        house: 'Casă',
        entrance: 'Scară',
        flat: 'Apartament',
        cash: 'Achitare în numerar',
        paymentAtPharmacyUponOrderReceipt: 'Achitarea se va efectua în farmacie la primirea comenzii',
        personalData: 'Datele personale',
        orderHistory: 'Istoria comenzilor',
        exit: 'Ieșire',
        favourites: 'Favorite',
        loyaltyCounts: 'Numărul de puncte de loialitate din cont:',
        name: 'Numele',
        surname: 'Prenumele',
        email: 'E-mail',
        emailChangeText: 'Pentru a schimba adresa de e-mail, contactați administratorul',
        phone: 'Telefon',
        birthday: 'Data nașterii',
        editPersonalData: 'Redactarea datelor personale',
        save: 'Salvează',
        companyData: 'Rechizitele companiei',
        companyName: 'Nume firma',
        vatRate: 'Rata TVA',
        vayNumber: 'Numărul TVA',
        companyAddress: 'Adresa juridica',
        physicAddress: 'Adresa fizica',
        bankName: 'Denumirea bancii',
        idno: 'Cod fiscal (IDNO)',
        bankCode: 'Codul bancii',
        iban: 'IBAN',
        orderDate: 'Data comenzii',
        orderTime: 'Ora comenzii',
        sum: 'Suma',
        deliveryMethod: 'Metoda de livrare',
        deliveryMethods: 'Metode de livrare',
        deliveryStatus: 'Status',
        quantity: 'Cantitatea',
        buyButtonText: 'Cumpără',
        findInPharmacy: 'Caută în farmacii',
        emptyCartTitle: 'Сoșul dvs. este gol.',
        emptySearchText: 'Nu sunt produse de afișat conform filtrului atribuit! Încerca-ți să resetați selecția Dvs',
        howToOrder: 'Cum comand',
        pharmaciesBranches: 'Găsește o farmacie',
        rePasswordErrorText: 'Parolele nu coincid',
        pct: 'pct',
        productCode: 'Cod produs',
        priceProductPoints: 'Preț produs în pct',
        requiredRecipe: 'eliberat doar cu rețetă!',
        or: 'sau',
        code: 'Cod produs:',
        costInCode: 'Preț produs în pct',
        enough: 'suficient',
        few: 'minim',
        noUserCartWarnTitle: 'Stimate Utilizator pentru a efectua o comandă este necesar să',
        noUserCartWarnButtonLabelAuth: 'autentificați',
        noUserCartWarnButtonLabelRegister: 'înregistrați',
        noUserCartWarnDescription:
            'Astfel veți avea acces deplin la produse favorite, comparate, abonări și Veți acumula puncte de loialitate pentru fiecare comandă ridicată!',
        noUserCartWarnDetails:
            'În caz că nu reușiți să vă înregistrați puteți plasa comanda la tel. 022106688 (va fi necesar să oferiți Numele Dvs. precum și un număr de telefon).',
        error: 'Eroare',
        errorNotFound: 'Cu părere de rău, informația solicitată nu este disponibilă pe această pagină',
        errorCategorylabel: 'Ar putea să fiți interesat de:',
        fastAccess: 'Acces rapid…',
        findPharmacy: 'Găsește o farmacie',
        setGift: 'Seturi Cadou',
        newProducts: 'Produse noi',
        specialOffer: 'Oferte Speciale',
        tipsAndRecommendations: 'Sfaturi și Recomandări',
        cabinet: 'Cabinet',
        product_not_available: 'PRODUSUL NU ESTE IN STOC TEMPORAR. ŞTERGETI PRODUSUL DIN COȘ.',
        not_available: 'PRODUSUL NU ESTE IN STOC TEMPORAR. ŞTERGETI PRODUSUL DIN COȘ.',
        not_reserved: 'PRODUSUL NU ESTE IN STOC TEMPORAR. ŞTERGETI PRODUSUL DIN COȘ.',
        price_mismatch: 'PRODUSUL NU ESTE IN STOC TEMPORAR. ŞTERGETI PRODUSUL DIN COȘ.',
        product_not_in_stock: 'Produsul nu mai este disponibil. Vă rugăm să îl eliminați din coș.',
        successOrderTitle: 'Felicitări! Ați finalizat procesul de comandă!',
        successOrderText:
            'Pentru medicamentele care sunt eliberate conform prescripțiilor de către medic, este necesar să se furnizeze o rețetă în farmacie. Cumpărătorul trebuie să verifice produsul în momentul primirii acestuia. În conformitate cu legislația în vigoare în Republica Moldova, medicamentele nu pot fi returnate după cumpărare!',
        ru: 'rusă',
        ro: 'română',
        communicationLanguage: 'Limba comunicării',
        m: 'masculin',
        f: 'feminin',
        successEditUserData: ' Modificările dvs. sunt salvate',
        payMethod: 'Metoda de achitare',
        sex: 'Sex',
        security: 'Securitate',
        oldPasswordError: 'Parola introdusă nu coincide ce parola curentă.',
        oldPasswordLabel: 'Parola veche',
        newPasswordLabel: 'Parola nouă',
        confirmPasswordLabel: 'Reintrodu parola nouă',
        passwordPlaceholder: 'Introdu parola',
        enterNewPassword: 'Introduceți o nouă parolă',
        setNewPassword: 'Setează o nouă parolă',
        viewedProducts: 'Produse vizualizate',
        find: 'Căutare',
        inCategory: 'în categorii',
        showAllProducts: 'Afișează toate produsele',
        allRightsReserved: 'Toate drepturile sunt rezervate',
        recipeText: 'Confirm prezența rețetei',
        contacts: 'Contacte',
        notAllFieldsFilledTitle:
            'Stimate utilizator, comanda nu poate fi plasată fără Nume Prenume, Telefon sau o adresă de email!',
        notAllFieldsFilledCabinetText: 'Datele pot fi adăugate în Cabinetul Personal, la rubrica date personale',
        notAllFieldsFilledEmailText:
            'În cazul în care nu reușiți să adăugați aceste date, vă rugăm să expediați ID-ul dumneavoastră și datele necesare la',
        priceWithoutDiscount: 'Pretul fara reducere',
        totalPriceWithDiscountAndPromo: 'Reducere totale / Cod promo',
        userWithPhoneNumberExists: 'Utilizator cu acest număr deja există.',
        authorization: 'Autorizare cu',
        expireText: 'Valabil până la',
        cartPromo: 'Promoție',
        nextStepError: 'Bifați, pentru a continua',
        minCartPriceError: 'Comanda minimă nu trebuie să fie mai mică de',
        minCartPriceErrorTitleStart: 'Se exclude minimul de',
        minCartPriceErrorTitleEnd: 'lei în caz că:',
        exception: 'excepție',
        exception1: '1. este prima comandă.',
        exception2: '2. comanda conține produse pe procurate pe puncte de loialitate.',
        exception3: '3. comanda are produse care participă în promoție și vaucerul se aplică cu succes.',
        emptyCompareText: 'Nu aveți produse de comparat!',
        notInStockText: 'Acest produs este temporar epuizat',
        video: 'Video',
        sortPriceMinus: 'mai ieftin',
        sortPricePlus: 'mai scump',
        sortNameMinus: 'ordine alfabetica',
        sortPriorityMinus: 'popular',
        catalogEmpty: ' Nu sunt produse de afișat conform filtrului atribuit! ',
        catalogFilterEmpty: ' Încerca-ți să resetați selecția Dvs ',
        showAll: 'Arată toate',
        showLess: 'Arată mai puține',
        sorting: 'Afișare',
        clearAllFilters: 'Șterge toate filtrele',
        newsletterSuccessText: 'Vă mulțumim pentru abonare la newsletter',
        showAllFilters: 'Afișează toate filtrele',
        successOrderLoaderText: 'Comanda DVS se procesează. Vă rugăm să așteptați pînă cînd va fi generată factura.'
    },
    companyNameLabel: 'Denumirea Companiei',
    cifLabel: 'C.I.F',
    registrationNumberLabel: 'Reg. Com',
    juridicalAddressLabel: 'Sediul',
    regionLabel: 'Judet',
    cityLabel: 'Localitate',
    bankNameLabel: 'Banca',
    accountIbanLabel: 'Cont/IBAN',
    inputNameLabel: 'Nume',
    inputNamePlaceholder: 'Numele dvs.',
    inputSurnameLabel: 'Prenumele',
    inputSurnamePlaceholder: 'Prenumele dvs.',
    formMessageNewPasswordSuccessfullySet: 'Parola nouă a fost setată',
    modalAgeRestrictionTitle: 'Confirmați-vă vârsta',
    modalAgeRestrictionMessageDisallowTitle: 'Această resursă este destinată exclusiv adulților.',
    modalAgeRestrictionMessageDisallowDescription:
        'Ne pare rău, nu puteți vizita acest site dacă aveți sub vârsta majoratului. În conformitate cu „Directiva 2001/37/CE a Parlamentului European și a Consiliului”',
    modalAgeRestrictionDescription:
        'Vă rugăm să confirmați că aveți peste 18 ani și sunteți de acord cu termenii de utilizare și prelucrarea datelor.',
    globalTextAttributeYes: 'Da',
    globalTextAttributeNo: 'Nu',
    deliveryCompanyTitle: 'Companie de curierat',
    sectionLockerActionChooseLocker: `Alegeți lockerul`,
    sectionLockerActionChangeLocker: `Schimbați lockerul`,
    sectionLockerFieldsLockerName: `Lockerul`,
    sectionLockerFieldsLockerAddress: `Adresa`,
    sectionLockerFieldsPostalCode: `Codul postal`,
    accountPersonalDataTitle: 'Date personale',
    globalActionChange: 'Editează',
    globalTextAttributeCabinet: 'Cabinet',
    accountOrdersHistoryTitle: 'Istoricul comenzilor',
    orderStatusPreorder: 'Pre-comanda',
    orderStatusAll: 'Toate comenzile',
    orderStatusNew: 'Comandă nouă',
    orderStatusConfirmed: 'Confirmat',
    orderStatusCanceled: 'Anulat',
    orderStatusClosed: 'Închis',
    orderStatusInCollection: 'În procesul de colectare',
    orderStatusCollectedWithChanges: 'Comanda colectată cu modificări',
    orderStatusToBeReturnedInTwoDays: 'Pentru a fi returnat în termen de 2 zile',
    orderStatusCollected: 'Comandă colectată',
    orderStatusCompletedAndClosed: 'Comandă finalizată/închisă',
    orderStatusReturnedToWarehouse: 'Comanda s-a întors la depozit',
    orderStatusChangedAndClosed: 'Comandă modificată și completată/închisă',
    orderStatusAtCourierSortCenter: 'Comandă trimisă la centrul de sortare courier',
    orderStatusOnDelivery: 'La livrare (cu curier)',
    orderStatusDeliveryDateMoved: 'Data de livrare/primire mutată',
    orderStatusClientNoAnswer: 'Clientul nu a răspuns',
    orderStatusRecipientNotAtHome: 'Destinatarul nu este la adresă',
    orderStatusCustomerRefusal: 'Refuzul clientului de a primi',
    orderSearchingInputPlaceholder: 'Căutare după numărul și/sau numele comenzii',
    orderStatusesPlaceholder: 'Statutul comenzii',
    orderInputPlaceholder: 'Căutare',
    orderDatePlaceholder: 'Data comenzii',
    accountHistoryTableColumnIdentificator: 'Numărul',
    accountHistoryTableColumnDate: 'Data emiterii',
    accountHistoryTableColumnDelivery: 'Tipul livrării',
    accountHistoryTableColumnStatus: 'Starea comenzii',
    accountHistoryTableColumnActions: 'Acțiuni',
    accountHistoryTableEmptyDescription: 'Încă nu ai nicio comandă',
    accountPersonalDataMessageSuccessfullySaving: 'Modificările au fost păstrate',
    confirmRegisterTextDynamic: 'La adresa {email} a fost trimis un link. Dați click pe acesta pentru a vă activa noul cont.',
    productsSliderRecentsTitle: 'Produse recente',
    pageFAQTitle: 'F.A.Q. Întrebări frecvente',
    footerLinkFaq: 'FAQ',
    checkoutSuccessSubtitleStatic: 'În curînd un consultant v-a lua legătura cu Dumneavoastră',
    globalTextAttributeOrder: 'Comandă',
    modalOrderCheckoutFieldStatus: 'Stare',
    modalOrderCheckoutFieldFullName: 'Nume complet',
    modalOrderCheckoutFieldPhone: 'Număr de telefon',
    modalOrderCheckoutFieldEmail: 'Email',
    modalOrderCheckoutFieldPayment: 'Metodă de plată',
    modalOrderCheckoutFieldDelivery: 'Metodă de livrare',
    modalOrderCheckoutFieldAddress: 'Adresă de livrare',
    modalOrderCheckoutFieldPrice: 'Costul livrării',
    modalOrderCheckoutFieldTotalPrice: 'Cost total al comenzii',
    globalTextErrorTryLater: 'A apărut o eroare . Vă rugăm să încercați din nou mai târziu.',
    checkoutSuccessStatusFailTitle: 'Eroare',
    checkoutSuccessStatusFailDescription: 'Plata comenzii dvs. a eșuat, vă rugăm să încercați din nou mai târziu',
    checkoutSuccessStatusPendingTitle: 'În procesare',
    checkoutSuccessStatusPendingDescription: 'Comanda dvs este în procesare.',
    globalTextAttributeActionSend: `Trimite`,
    globalTextAttributeForgotPassword: `Ați uitat parola?`,
    globalTextAttributeRecover: `Recuperează`,
    globalTextAttributeNoAccount: `Nu aveți cont?`,
    globalTextAttributeSignUp: `Înregistrează`,
    globalTextActionChangePassword: `Schimbați parola`,
    globalTextAttributeSamePasswords: 'Parolele nu coincid',
    globalTextAttributeHaveAccount: `Ai cont?`,
    globalActionSignIn: `Logează-te`,
    globalTextAttributePhysicalPerson: `Persoană fizică`,
    globalTextAttributeJuridicalPerson: `Persoană juridică`,
    formDeliveryInputStreetLabel: 'Stradă',
    formDeliveryInputHouseLabel: 'Casă',
    formDeliveryInputEntranceLabel: 'Scară',
    formDeliveryInputFlatLabel: 'Apartament',
    streetPlaceholder: 'ex: Aviatorilor',
    housePlaceholder: 'ex: Nr. 10',
    entrancePlaceholder: 'ex: A',
    flatPlaceholder: 'ex: Ap. 5',
    formSendContactMessageTitle: 'Lasă mesajul tău',
    formSendContactMessageMessageSuccess: 'Mesajul a fost trimis cu succes',
    globalTextAttributeFreeShipping: 'Livrare gratuită',
    headerTopDownloadCatalogBtn: 'Descarcă catalogul',
    headerTopAboutCompany: 'Despre companie',
    headerTopWholesaleSales: 'Angro',
    headerTopForCustomers: 'Pentru clienți',
    headerTopQuality: 'Calitate',
    headerTopIn: 'în',
    subscribeTitle: 'Abonează-te!',
    subscribeText: 'și fii primul care află despre promoțiile noastre.',
    fullTermsAndConditions: 'Eu sunt de acord cu termeni și politica de confidențialitate',
    subscribeButtonText: 'Abonează-te',
    subscribeSuccess: 'Vă mulțumim pentru abonarea la newsletter!',
    cartEmpty: 'Încă nu e nimic aici',
    globalTextAttributeEmailEditInfo: 'Pentru a schimba adresa de e-mail, contactați administratorul',
    brandsTitle: 'Branduri',
    pageBrandsSectionEmptyDescription: 'Acest brand momentan nu conține produse',
    formSendContactInputeMessageLabel: 'Mesaj',
    pageBrandsSectionEmptyListDescription: 'Momentan pagina nu conține branduri',
    globalTextAttribute: `Brand`,
    confirmResetTextDynamic: 'La adresa {email} a fost trimis un link. Dați click pe acesta pentru a vă reseta parola.',
    confirmResetText: 'La adresa de e-mail specificată a fost trimis un link. Dați click aici pentru a vă reseta parola.',
    tempLinkText1: 'Politica de Returnare a Comenzilor',
    tempLinkText2: 'Politica de livrare a comenzilor',
    tempLinkText3: 'Politica GDPR',
    promoCode: 'Cod promo',
    promoCodePlaceholder: 'Introduceți codul promo',
    applyButtonText: 'Aplică',
    formSendContactInputeMessagePlaceholder: 'Scrieți propriul mesaj',
    requestDeleteProfileButton: 'Ștergeți contul',
    requestDeleteProfileTitle: 'Ștergerea contului',
    requestDeleteProfileQuestion: 'Sunteți sigur că doriți să ștergeți contul?',
    requestDeleteProfileText: `Ștergerea contului va duce la pierderea ireversibilă a tuturor datelor`,
    requestDeleteProfileConfirm: 'Da, aș dori să șterg',
    requestDeleteProfileCancel: 'Abolire',
    confirmDeleteProfileText: 'Pentru a finaliza ștergerea contului personal, accesați linkul din e-mail.',
    profileHasBeenDeleted: ' Contul dumneavoastră a fost șters cu succes',
    workHours: 'Orar de lucru',
    passwordLengthError: 'Parola trebuie să conțină între 6 și 50 de caractere.',
    storeAddress: 'Adresa magazinului',
    profileDeleteError: 'A apărut o eroare la ștergerea contului',
    uniplastBrandsTitle: 'Suntem distribuitori oficiali ai brandurilor:',
    creditCalculator: {
        name: 'Calculator de credit',
        creditType: 'Selectați tipul de credit',
        termDay: 'Termen (în zile)',
        probe: 'Probă',
        sum: 'Sumă',
        grams: 'Grame',

        availableSum: 'Sumă disponibilă:',
        costCredit: 'Costul creditului:',
        totalCost: 'Total de plătit:',
        dae: 'DAE:',
        contactInfo: 'Informații de contact',
        filial: 'Selectați filiala',
        filialPlaceholder: 'Nimic selectat',
        contactName: 'Nume',
        contactNamePlaceholder: 'Introduceți numele',
        phone: 'Telefon',
        phonePlaceholder: '+373  ХХ ХХ ХХ ХХ',
        sendRequest: 'Trimiteți cererea',
        formSuccess: 'Formularul a fost completat cu succes!',
        weGotYourMsg: 'Am primit mesajul dumneavoastră și vă vom contacta în curând',
        complete: 'Finalizați',
        errorMsg: 'Nu există contract disponibil pentru aceste date'
    },
    modalOrderCheckoutFieldCompany: 'Denumirea companiei',
    modalOrderCheckoutFieldFiscalCode: 'Cod fiscal (IDNO)',
    modalOrderCheckoutFieldAddressJuridical: 'Adresa juridcă',
    modalOrderCheckoutFieldIban: 'IBAN',
    modalOrderCheckoutFieldBankCode: 'CODUL BĂNCII',
    categories: 'Categorii',
    products: 'Produse',
    productNotAvailable: 'Produsul nu mai este activ. Treceți în catalog.',
    productsOnOfferTitle: 'Produse la ofertă',
    casaMobileMenuTitle: 'Menu',
    casaMobileLoginButtonText: 'Intra in cont',
    casaMobileThemeDarkModeText: 'Mod Intunecat',
    casaMobileThemeLightModeText: 'Light Mode',
    productNotInStock: `Produsul - {name} nu mai este disponibil în această cantitate. Cantitate disponibilă - {count}`,
    productIsNotAvailable: `Produsul - {name} nu este temporar în stoc. Ștergeți produsul din coș.`,
    modalFacebookLoginErrorText:
        '<span>Din păcate, a apărut o eroare.</span>' + '<span>Adăugați email-ul în contul rețelei sociale.</span>',
    reviewsTitle: `Recenziile produsului`,
    reviewsSectionEmptyDescription: `Nimeni încă nu a scris o recenzie despre acest produs. Împărtășiți-vă experiența cu alții.`,
    reviewsActionCreateReview: `Scrie o recenzie`,
    modalSendProductReviewTitle: `Lasă o recenzie`,
    modalSendProductReviewFormTitle: `Apreciază produsul`,
    modalSendProductReviewFormInputMessageLabel: `Recenzia ta`,
    modalSendProductReviewFormInputEmailLabel: `Email`,
    modalSendProductReviewFormInputUnitVeryBad: `Foarte rău`,
    modalSendProductReviewFormInputUnitBad: `Rău`,
    modalSendProductReviewFormInputUnitNormal: `Normal`,
    modalSendProductReviewFormInputUnitGood: `Bine`,
    modalSendProductReviewFormInputUnitExcelent: `Excelent`,
    modalSendProductReviewFormMessageRequired: `Completati toate câmpurile necesare`,
    modalSendProductReviewFormMessageRequestFailed: `Selectati nota ratingului produsului`,
    modalSendProductReviewFormMessageRequestSuccess: `Recenzia dumneavoastra a fost trimisa cu succes`,
    globalTextAttributeReviews: `recenzii`,
    globalTextAttributeWrite: `Scrie...`,
    globalTextAttributePlaceholderEmail: `example@email.com`,
    minimalCostOfCart: `Valoarea minimă a coșului este de {count} lei. Vă rugăm să verificați lista de produse.`,
    mainPageShowMoreButtonText: 'Arată mai mult',
    mainPageShowLessButtonText: 'Arată mai puțin',
    category: 'Categorii',
    selectDateLabel: 'Selectați ora livrării',
    taxInfo: 'Taxa estimată de colectat',
    taxTitle: 'Calculul livrării',
    deliveryData: {
        postmachine: 'Poștomat',
        courier: 'Curier',
        warehouse: 'Depozit',
        nothingFound: 'Nu a fost găsit nimic.',
        country: 'Țara',
        shippingAddress: 'Adresa de livrare',
        state: 'Stat / Provincie',
        city: 'Oraș',
        street: 'Stradă',
        zipCode: 'Cod poștal',
        countryPlaceholder: 'Selectează țara',
        statePlaceholder: 'Selectează stat / provincie',
        cityPlaceholder: 'Specificați oraș',
        zipCodePlaceholder: 'Indică codul poștal',
        postmachinePlaceholder: 'Specificați poștomat',
        warehousePlaceholder: 'Specificați depozit',
        streetPlaceholder: 'Specificați adresa',
        date: 'Data livrării'
    }
};
